import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  all_links,
  class10_soln,
  class11_soln,
  class12_soln,
  class9_soln,
  rdsharma_soln,
} from "../data/links";
import HelmetTags from "../components/HelmetTags";
import "../styles/subject.css";
import Card from "../components/Card";

function Subject() {
  const { class_name } = useParams();
  const [subjects, setSubjects] = useState();
  useEffect(() => {
    if (class_name === "rd-sharma-solutions") {
      setSubjects(rdsharma_soln);
    } else if (class_name === "ncert-solutions-class-12") {
      setSubjects(class12_soln);
    } else if (class_name === "ncert-solutions-class-11") {
      setSubjects(class11_soln);
    } else if (class_name === "ncert-solutions-class-10") {
      setSubjects(class10_soln);
    } else if (class_name === "ncert-solutions-class-9") {
      setSubjects(class9_soln);
    } else if (class_name === "all-solutions") {
      setSubjects(all_links);
    }
  }, [subjects, class_name]);

  return (
    <div className="subject container page">
      <HelmetTags
        title={`${class_name.replace(/-/g, " ").toUpperCase()}`}
        desc={`${class_name.replace(/-/g, " ").toUpperCase()}`}
        route={`${class_name}`}
      />
      <h2>{class_name.replace(/-/g, " ").toUpperCase()}</h2>
      <p>
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <a href="/">home</a>
            </li>

            <li
              class="breadcrumb-item active"
              aria-current="page"
            >{`${class_name}`}</li>
          </ol>
        </nav>
      </p>

      <div className="subject-cards">
        {subjects?.map((solution) => (
          <>
            <Link to={solution.link}>
              <Card
                title={solution.title}
                desc={`Click Here to view ${solution.title}.`}
                sub={solution.link}
              />
            </Link>
          </>
        ))}{" "}
      </div>
    </div>
  );
}

export default Subject;
